// eslint-disable-next-line @typescript-eslint/no-unused-vars
const noop = (..._: unknown[]): void => {};

export default noop;
